export const headerStyles = {
  typography: {
    display: "flex",
    margin: "0 16px 0 16px",
    alignItems: "center",
    color: "white",
    height: "100px",
    cursor: "pointer",
    "&:hover": {
      color: "#FA496E",
    },
  },
};
